export default function render(suggestion) {
	const { url, formattedTerm } = suggestion;

	return `<a href="${url}" class="autocomplete-results-list__link clearfix">
	<span class="autocomplete-results-list__title autocomplete-results-list__title--suggestion">${formattedTerm}</span>
</a>`;
}
